import { Injectable } from '@angular/core';
import { API_ENDPOINT, GLOBAL_DATA_KEY } from '@core/configs';
import { ApiService } from '@core/services/common';
import { GlobalDataService } from '../common/global-data.service';
import { ScreenConfigRequestModel } from '@core/models/request/screen-config.model';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScreenConfigService {
  constructor(
    private readonly http: ApiService,
    private readonly globalDataService: GlobalDataService
  ) {
  }

  async save(jsonData: string) {
    const corpPrefix = this.globalDataService.get(GLOBAL_DATA_KEY.corpPrefix);
    const officeCd = this.globalDataService.get(GLOBAL_DATA_KEY.officeCd);
    const staffCd = this.globalDataService.get(GLOBAL_DATA_KEY.staffCd);
    const url = `${API_ENDPOINT.screenConfig.save}`;
    const pk = `corp_${corpPrefix}#office_${officeCd}#staff_${staffCd}`;
    const body = new ScreenConfigRequestModel(pk, jsonData);
    return await lastValueFrom(this.http.post(url, body));
  }

  async getByStaff() {
    const corpPrefix = this.globalDataService.get(GLOBAL_DATA_KEY.corpPrefix);
    const officeCd = this.globalDataService.get(GLOBAL_DATA_KEY.officeCd);
    const staffCd = this.globalDataService.get(GLOBAL_DATA_KEY.staffCd);

    const body = {
      "CorpPrefix": corpPrefix,
      "OfficeCd": officeCd,
      "StaffCd": staffCd
    };
    const url = `${API_ENDPOINT.screenConfig.getByStaff}`;
    return await lastValueFrom(this.http.post(url, body));
  }

}
